import { z } from 'zod'

export const DnsTemplateRecord = z.object({
  name: z.string(),
  type: z.string(),
  content: z.string(),
  ttl: z.number().int().optional(),
  priority: z.number().int().optional()
})

export type DnsTemplateRecord = z.infer<typeof DnsTemplateRecord>

export const DnsTemplate = z.object({
  id: z.string(),
  name: z.string().min(1),
  description: z.string().optional(),
  records: z.array(DnsTemplateRecord),
  isBuiltin: z.boolean().default(false),
  createdAt: z.string().optional()
})

export type DnsTemplate = z.infer<typeof DnsTemplate>

// Built-in templates
export const BUILTIN_TEMPLATES: DnsTemplate[] = [
  {
    id: 'builtin-basic-website',
    name: 'Basis Website',
    description: 'A und CNAME Einträge für eine einfache Website',
    isBuiltin: true,
    records: [
      { name: '', type: 'A', content: '', ttl: 3600 },
      { name: 'www', type: 'CNAME', content: '@', ttl: 3600 }
    ]
  },
  {
    id: 'builtin-google-workspace',
    name: 'Google Workspace',
    description: 'MX und TXT Einträge für Google Workspace Email',
    isBuiltin: true,
    records: [
      { name: '', type: 'MX', content: 'aspmx.l.google.com', ttl: 3600, priority: 1 },
      { name: '', type: 'MX', content: 'alt1.aspmx.l.google.com', ttl: 3600, priority: 5 },
      { name: '', type: 'MX', content: 'alt2.aspmx.l.google.com', ttl: 3600, priority: 5 },
      { name: '', type: 'MX', content: 'alt3.aspmx.l.google.com', ttl: 3600, priority: 10 },
      { name: '', type: 'MX', content: 'alt4.aspmx.l.google.com', ttl: 3600, priority: 10 },
      { name: '', type: 'TXT', content: 'v=spf1 include:_spf.google.com ~all', ttl: 3600 }
    ]
  },
  {
    id: 'builtin-microsoft-365',
    name: 'Microsoft 365',
    description: 'MX und TXT Einträge für Microsoft 365 Email',
    isBuiltin: true,
    records: [
      { name: '', type: 'MX', content: '', ttl: 3600, priority: 0 },
      { name: '', type: 'TXT', content: 'v=spf1 include:spf.protection.outlook.com -all', ttl: 3600 },
      { name: 'autodiscover', type: 'CNAME', content: 'autodiscover.outlook.com', ttl: 3600 }
    ]
  },
  {
    id: 'builtin-mailserver',
    name: 'Eigener Mailserver',
    description: 'MX, SPF und DMARC für eigenen Mailserver',
    isBuiltin: true,
    records: [
      { name: '', type: 'MX', content: 'mail', ttl: 3600, priority: 10 },
      { name: 'mail', type: 'A', content: '', ttl: 3600 },
      { name: '', type: 'TXT', content: 'v=spf1 mx -all', ttl: 3600 },
      { name: '_dmarc', type: 'TXT', content: 'v=DMARC1; p=quarantine; rua=mailto:dmarc@', ttl: 3600 }
    ]
  },
  {
    id: 'builtin-subdomain-redirect',
    name: 'Subdomain Weiterleitung',
    description: 'CNAME Einträge für gängige Subdomains',
    isBuiltin: true,
    records: [
      { name: 'www', type: 'CNAME', content: '@', ttl: 3600 },
      { name: 'blog', type: 'CNAME', content: '@', ttl: 3600 },
      { name: 'shop', type: 'CNAME', content: '@', ttl: 3600 },
      { name: 'app', type: 'CNAME', content: '@', ttl: 3600 }
    ]
  }
]
